import React from 'react'
import LeftArrow from '../icons/LeftArrow'
import RightArrow from '../icons/RightArrow'

const Table = ({ headings, checkbox = false, rows }) => {

    return (
        <div className='mt-4 p-5  rounded-[10px] bg-[#fff] ' style={{ border: "1px solid rgba(5, 63, 146, 0.24)" }}>
            <div className='min-h-[600px] overflow-auto'>
                <table className="w-full border-collapse">
                    <thead>
                        <tr align="center" style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.10)" }}>
                            {
                                checkbox && (
                                    <th align='center' className="py-2 text-center px-4  font-normal" style={{ color: "rgba(0, 0, 0, 0.64)" }}>
                                        1
                                    </th>
                                )
                            }
                            {
                                headings?.map((heading, index) => (
                                    <th key={index} align='center' className="py-2 text-center px-4  font-normal" style={{ color: "rgba(0, 0, 0, 0.64)" }}>{heading}</th>
                                ))
                            }
                            {/* Add more header cells as needed */}
                        </tr>
                    </thead>
                    <tbody className='table-body'>
                        <tr style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.10)", height: "62px" }}>
                            {
                                checkbox && (
                                    <td align='center' className="py-2 px-4">1</td>
                                )
                            }
                            <td align='center' className="py-2 px-4">Row 1, Cell 1</td>
                            <td align='center' className="py-2 px-4">Row 1, Cell 2</td>
                            <td align='center' className="py-2 px-4">Row 1, Cell 1</td>
                            <td align='center' className="py-2 px-4">Row 1, Cell 2</td>
                            <td align='center' className="py-2 px-4">Row 1, Cell 1</td>
                            <td align='center' className="py-2 px-4">Row 1, Cell 2</td>
                            <td align='center' className="py-2 px-4">Row 1, Cell 2</td>
                            {/* Add more cells as needed */}
                        </tr>
                        <tr>
                            {
                                checkbox && (
                                    <td align='center' className="py-2 px-4">1</td>
                                )
                            }
                            <td align='center' className="py-2 px-4">Row 1, Cell 1</td>
                            <td align='center' className="py-2 px-4">Row 1, Cell 2</td>
                            <td align='center' className="py-2 px-4">Row 1, Cell 1</td>
                            <td align='center' className="py-2 px-4">Row 1, Cell 2</td>
                            <td align='center' className="py-2 px-4">Row 1, Cell 1</td>
                            <td align='center' className="py-2 px-4">Row 1, Cell 2</td>
                            <td align='center' className="py-2 px-4">Row 1, Cell 2</td>
                            {/* Add more cells as needed */}
                        </tr>
                        {/* Add more rows as needed */}
                    </tbody>
                </table>
            </div>


            {/* Pagination Flex */}
            <div className='flex mt-3 justify-center items-center'>
                <div className='flex text-[#777] text-[16px] space-x-4 items-center'>
                    <LeftArrow />
                    <p>1</p>
                    <p>2</p>
                    <p className='bg-[#3F93FF] py-1 px-3 rounded-[5px] text-white'>3</p>
                    <p>4</p>
                    <p>5</p>
                    <p>...</p>
                    <p>40</p>
                    <RightArrow />
                </div>
            </div>

        </div>
    )
}

export default Table